import axios from 'axios'

import { getDefaultHeaders } from './httpUtils'

const http = axios.create()

http.putFile = (url, fieldName, file, method, config = {}) => {
  method = (method && method.toLowerCase()) || 'put'
  const fd = new FormData()
  fd.append(fieldName, file)
  return http[method](url, fd, {
    ...config,
    headers: {
      ...getDefaultHeaders(),
      ...(config?.headers || {}),
    },
  })
}

http.sendMultipartForm = (url, form, method, config = {}) => {
  const fd = new FormData()
  Object.keys(form).map((elem) => fd.append(elem, form[elem]))
  return http[(method && method.toLowerCase()) || 'post'](url, fd, {
    ...config,
    headers: {
      ...getDefaultHeaders(),
      ...(config?.headers || {}),
    },
  })
}

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error.response
    const message = response?.data?.message || 'Error'
    return Promise.reject(message)
  }
)

export default http
